import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { resclose, rescloseId } from '../../../paths/defaultImage';
import LazyImage from '../../common/lazyLoad';

const RestaurantClosed = () => {
  const { t } = useTranslation();
  const currentLanguage = i18next.resolvedLanguage;

  return (
    <div className='d-flex flex-column align-items-center text-center px-20 gap-2'>
      <LazyImage
        width='250px'
        height='150px'
        src={currentLanguage == 'en' ? resclose : rescloseId}
        alt='closed'
      />
      <div className='appSubHeader fw-700 fs-20'>{t('oops_restaurant_closed')}</div>
      <div className='appSubHeader fs-12'>
        {t('sorry_this_restaurant')}
        <br />
        {t('you_can_find')}
      </div>
    </div>
  );
};

export default RestaurantClosed;
